import { RemirrorJSON } from "@remirror/core";

export function isRemirrorJSONEmpty(
  notesJson: RemirrorJSON | undefined,
): boolean {
  if (!notesJson) {
    return true;
  }
  // If the node has a text property and it is not empty, return false
  if (notesJson.text && notesJson.text.trim() !== "") {
    return false;
  }

  // If the node has content, recursively check each child node
  if (notesJson.content && notesJson.content.length > 0) {
    return notesJson.content.every(isRemirrorJSONEmpty);
  }

  // If the node has no text and no content, it is empty
  return true;
}
